export const RiseLogo = () => (
  <svg viewBox="0 0 120 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_74)">
      <mask
        id="mask0_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="17"
        y="32"
        width="86"
        height="86"
      >
        <path
          d="M17.4396 75C17.4396 98.5025 36.4904 117.56 60 117.56C83.5096 117.56 102.56 98.5096 102.56 75C102.56 51.4904 83.5096 32.4396 60 32.4396C36.4904 32.4396 17.4396 51.4904 17.4396 75Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1_74)">
        <path
          d="M102.553 32.4396H17.4396V117.553H102.553V32.4396Z"
          fill="url(#paint0_linear_1_74)"
        />
      </g>
      <path
        d="M60 33.3795C83.3471 33.3795 102.299 52.1829 102.553 75.4664C102.553 75.3109 102.553 75.1555 102.553 75C102.553 51.4975 83.5025 32.4396 59.9929 32.4396C36.4833 32.4396 17.4326 51.4904 17.4326 75C17.4326 75.1555 17.4326 75.3109 17.4326 75.4664C17.687 52.1758 36.6388 33.3795 59.9859 33.3795"
        fill="#EDEDED"
      />
      <path
        d="M60 116.621C36.6529 116.621 17.7011 97.8171 17.4467 74.5336C17.4467 74.6891 17.4467 74.8446 17.4467 75C17.4467 98.5025 36.4975 117.56 60.0071 117.56C83.5167 117.56 102.567 98.5096 102.567 75C102.567 74.8446 102.567 74.6891 102.567 74.5336C102.313 97.8242 83.3612 116.621 60.0141 116.621"
        fill="#EDEDED"
      />
      <path
        d="M27.8201 51.8296H38.3559C42.4685 51.8296 44.5248 53.9777 44.5248 58.2599V67.5168C44.5248 70.7956 43.4578 72.866 41.3308 73.7351L45.083 89.3729H39.9812L36.448 74.2086H33.1975V89.3729H27.813V51.8296H27.8201ZM33.2046 69.9193H36.7377C38.3418 69.9193 39.1473 69.0148 39.1473 67.1988V59.0938C39.1473 57.2848 38.3418 56.3732 36.7377 56.3732H33.2046V69.9123V69.9193Z"
        fill="#1F2124"
      />
      <path
        d="M53.8311 51.8296H48.4466V89.3729H53.8311V51.8296Z"
        fill="#1F2124"
      />
      <path
        d="M68.628 61.9203V58.6274C68.628 57.1293 67.8436 56.3803 66.2749 56.3803H65.434C63.9006 56.3803 63.1375 57.1293 63.1375 58.6274V64.8528C63.1375 65.5453 63.2858 66.0187 63.5826 66.2661C63.8794 66.5063 64.367 66.8243 65.0383 67.2059L70.1402 69.7639C71.2637 70.3574 72.0551 70.8168 72.5215 71.1489C72.9879 71.481 73.3553 71.8838 73.6168 72.3501C73.8782 72.8236 74.0054 73.721 74.0054 75.0424V83.0415C74.0054 87.26 71.8361 89.3658 67.5044 89.3658H64.1974C59.9011 89.3658 57.7529 87.0622 57.7529 82.462V80.5753H63.1375V82.6175C63.1375 84.0802 63.943 84.8151 65.5471 84.8151H66.501C67.9213 84.8151 68.628 84.0802 68.628 82.6175V76.2366C68.628 75.5371 68.4796 75.0707 68.1828 74.8234C67.886 74.5831 67.3984 74.2651 66.7271 73.8835L61.6253 71.2195C60.5017 70.6613 59.6891 70.1949 59.1874 69.8063C58.6857 69.4247 58.3182 68.9301 58.0921 68.3153C57.866 67.7076 57.7529 66.9162 57.7529 65.9339V58.2458C57.7529 53.9566 59.9011 51.8155 64.1974 51.8155H67.561C71.8573 51.8155 74.0054 53.9566 74.0054 58.2458V61.9061H68.6209L68.628 61.9203Z"
        fill="#1F2124"
      />
      <path
        d="M77.9343 89.3658V51.8296H91.2754V56.3732H83.3117V67.7712H90.378V72.3219H83.3117V84.8222H91.2754V89.3658H77.9343Z"
        fill="#1F2124"
      />
      <path
        d="M40.4405 100.743L41.9809 93.4572H43.8111V105.859H42.1505L42.3272 97.7394L41.0835 103.611H39.8045L38.5608 97.7394L38.7304 105.859H37.0769V93.4572H38.9071L40.4405 100.743Z"
        fill="#1F2124"
      />
      <path
        d="M47.2806 105.859C45.9451 105.859 45.2738 105.159 45.2738 103.753V95.5841C45.2738 94.1709 45.938 93.4572 47.2594 93.4572H48.8494C50.1708 93.4572 50.835 94.1638 50.835 95.5841V103.753C50.835 105.159 50.1637 105.859 48.8352 105.859H47.2806ZM47.6763 104.353H48.5243C48.9624 104.353 49.1815 104.113 49.1815 103.626V95.6831C49.1815 95.2026 48.9342 94.9552 48.4395 94.9552H47.6622C47.1817 94.9552 46.9344 95.1955 46.9344 95.6831V103.626C46.9344 104.106 47.1817 104.353 47.6763 104.353Z"
        fill="#1F2124"
      />
      <path
        d="M56.2478 105.859H52.3119V93.4572H53.9654V104.353H56.2478V105.859Z"
        fill="#1F2124"
      />
      <path
        d="M57.1947 105.859V93.4572H60.0777C61.6323 93.4572 62.4096 94.2486 62.4096 95.8385V104.064C62.4096 105.258 61.7454 105.859 60.424 105.859H57.1947ZM58.8553 104.353H60.0989C60.537 104.353 60.7561 104.17 60.7561 103.802V95.8527C60.7561 95.252 60.5088 94.9552 60.0141 94.9552H58.8553V104.353Z"
        fill="#1F2124"
      />
      <path
        d="M65.8015 105.859C64.4659 105.859 63.7946 105.159 63.7946 103.753V95.5841C63.7946 94.1709 64.4588 93.4572 65.7802 93.4572H67.3702C68.6916 93.4572 69.3558 94.1638 69.3558 95.5841V103.753C69.3558 105.159 68.6845 105.859 67.356 105.859H65.8015ZM66.1972 104.353H67.0451C67.4832 104.353 67.7023 104.113 67.7023 103.626V95.6831C67.7023 95.2026 67.455 94.9552 66.9603 94.9552H66.183C65.7025 94.9552 65.4552 95.1955 65.4552 95.6831V103.626C65.4552 104.106 65.7025 104.353 66.1972 104.353Z"
        fill="#1F2124"
      />
      <path
        d="M76.196 93.4572L74.1962 105.859H72.2247L70.2179 93.4572H71.8643L73.2069 102.919L74.5566 93.4572H76.196Z"
        fill="#1F2124"
      />
      <path
        d="M78.549 105.859H76.8885V95.5841C76.8885 94.1709 77.5527 93.4572 78.8741 93.4572H80.1178C81.4392 93.4572 82.1034 94.1638 82.1034 95.5841V105.859H80.4428V101.315H78.542V105.859H78.549ZM80.4499 99.8098V95.6831C80.4499 95.2026 80.2096 94.9552 79.722 94.9552H79.2698C78.7822 94.9552 78.542 95.1955 78.542 95.6831V99.8098H80.4428H80.4499Z"
        fill="#1F2124"
      />
      <mask
        id="mask1_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="15"
        width="58"
        height="58"
      >
        <path
          d="M0 72.1593H7.27829C8.69862 45.2579 30.2579 23.6986 57.1593 22.2783V15C26.2443 16.4345 1.44153 41.2443 0 72.1593Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1_74)">
        <path
          d="M57.1593 15H0V72.1593H57.1593V15Z"
          fill="url(#paint1_radial_1_74)"
        />
      </g>
      <mask
        id="mask2_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="77"
        width="58"
        height="58"
      >
        <path
          d="M0 77.8336C1.44153 108.749 26.2443 133.558 57.1593 134.993V127.715C30.2579 126.287 8.69862 104.728 7.27829 77.8336H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_1_74)">
        <path
          d="M57.1593 77.8336H0V134.993H57.1593V77.8336Z"
          fill="url(#paint2_radial_1_74)"
        />
      </g>
      <mask
        id="mask3_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="62"
        y="77"
        width="58"
        height="58"
      >
        <path
          d="M112.722 77.8336C111.294 104.735 89.735 126.294 62.8406 127.715V134.993C93.7557 133.558 118.566 108.749 120 77.8336H112.722Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_1_74)">
        <path
          d="M119.993 77.8336H62.8335V134.993H119.993V77.8336Z"
          fill="url(#paint3_radial_1_74)"
        />
      </g>
      <mask
        id="mask4_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="62"
        y="15"
        width="58"
        height="58"
      >
        <path
          d="M62.8336 22.2783C89.735 23.7057 111.294 45.265 112.715 72.1593H119.993C118.558 41.2443 93.7557 16.4345 62.8336 15V22.2783Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_1_74)">
        <path
          d="M119.993 15H62.8336V72.1593H119.993V15Z"
          fill="url(#paint4_radial_1_74)"
        />
      </g>
      <mask
        id="mask5_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="62"
        y="15"
        width="58"
        height="58"
      >
        <path
          d="M62.8336 22.2783C89.735 23.7057 111.294 45.265 112.715 72.1593H119.993C118.558 41.2443 93.7557 16.4345 62.8336 15V22.2783Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_1_74)">
        <path
          d="M119.993 15H62.8336V72.1593H119.993V15Z"
          fill="url(#paint5_radial_1_74)"
        />
      </g>
      <mask
        id="mask6_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="7"
        y="77"
        width="51"
        height="51"
      >
        <path
          d="M7.22884 77.8336C8.71983 104.728 30.265 126.273 57.1593 127.764V120.33C34.3634 118.854 16.1324 100.63 14.6555 77.8265H7.22177L7.22884 77.8336Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_1_74)">
        <path
          d="M57.1594 77.8336H7.22888V127.764H57.1594V77.8336Z"
          fill="url(#paint6_radial_1_74)"
        />
      </g>
      <mask
        id="mask7_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="7"
        y="22"
        width="51"
        height="51"
      >
        <path
          d="M7.22882 72.1593H14.6626C16.1394 49.3634 34.3634 31.1324 57.1664 29.6555V22.2288C30.265 23.7198 8.71981 45.265 7.22882 72.1593Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7_1_74)">
        <path
          d="M57.1593 22.2288H7.22882V72.1593H57.1593V22.2288Z"
          fill="url(#paint7_radial_1_74)"
        />
      </g>
      <mask
        id="mask8_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="62"
        y="77"
        width="51"
        height="51"
      >
        <path
          d="M105.337 77.8336C103.861 100.629 85.6366 118.861 62.8336 120.337V127.771C89.7279 126.28 111.273 104.735 112.764 77.8407H105.33L105.337 77.8336Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask8_1_74)">
        <path
          d="M112.764 77.8336H62.8336V127.764H112.764V77.8336Z"
          fill="url(#paint8_radial_1_74)"
        />
      </g>
      <mask
        id="mask9_1_74"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="62"
        y="22"
        width="51"
        height="51"
      >
        <path
          d="M62.8336 29.6555C85.6295 31.1324 103.861 49.3564 105.337 72.1593H112.771C111.28 45.265 89.735 23.7198 62.8407 22.2288V29.6555H62.8336Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask9_1_74)">
        <path
          d="M112.764 22.2288H62.8336V72.1593H112.764V22.2288Z"
          fill="url(#paint9_radial_1_74)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_74"
        x1="59.3934"
        y1="32.5619"
        x2="59.3934"
        y2="117.676"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#DADADA" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.001 75.0235) scale(60.0707)"
      >
        <stop stopColor="#A8110C" />
        <stop offset="0.89" stopColor="#A9110C" />
        <stop offset="0.93" stopColor="#C40E10" />
        <stop offset="0.97" stopColor="#D50D13" />
        <stop offset="1" stopColor="#DC0D15" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.789 74.3522) scale(60.0707)"
      >
        <stop stopColor="#B55103" />
        <stop offset="0.89" stopColor="#B55103" />
        <stop offset="0.9" stopColor="#BA5303" />
        <stop offset="0.94" stopColor="#D55D05" />
        <stop offset="0.97" stopColor="#E66307" />
        <stop offset="1" stopColor="#EC6608" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.4356 74.1048) scale(60.0707)"
      >
        <stop stopColor="#14822C" />
        <stop offset="0.89" stopColor="#14822C" />
        <stop offset="0.92" stopColor="#138E30" />
        <stop offset="0.96" stopColor="#139F36" />
        <stop offset="1" stopColor="#13A538" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.9091 74.43) scale(60.0707)"
      >
        <stop stopColor="#005B94" />
        <stop offset="0.89" stopColor="#005B94" />
        <stop offset="0.93" stopColor="#0067A8" />
        <stop offset="0.97" stopColor="#0071B9" />
        <stop offset="1" stopColor="#0075BF" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.9091 74.43) scale(60.0707)"
      >
        <stop stopColor="#005B94" />
        <stop offset="0.89" stopColor="#005B94" />
        <stop offset="0.93" stopColor="#0067A8" />
        <stop offset="0.97" stopColor="#0071B9" />
        <stop offset="1" stopColor="#0075BF" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.0505 74.7197) scale(53.0044)"
      >
        <stop stopColor="#F7A823" />
        <stop offset="0.88" stopColor="#F7A823" />
        <stop offset="0.9" stopColor="#F4971C" />
        <stop offset="0.94" stopColor="#EF7C11" />
        <stop offset="0.97" stopColor="#EC6B0A" />
        <stop offset="1" stopColor="#EC6608" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.313 74.9974) scale(53.0114)"
      >
        <stop stopColor="#E6412C" />
        <stop offset="0.88" stopColor="#E53E2A" />
        <stop offset="0.93" stopColor="#E0231E" />
        <stop offset="0.97" stopColor="#DD1217" />
        <stop offset="1" stopColor="#DC0D15" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.7325 74.974) scale(53.0044)"
      >
        <stop stopColor="#74B959" />
        <stop offset="0.88" stopColor="#74B959" />
        <stop offset="0.89" stopColor="#69B655" />
        <stop offset="0.92" stopColor="#44AF48" />
        <stop offset="0.95" stopColor="#29A93F" />
        <stop offset="0.98" stopColor="#18A639" />
        <stop offset="1" stopColor="#13A538" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_1_74"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.8526 75.0305) scale(53.0044)"
      >
        <stop stopColor="#1488CA" />
        <stop offset="0.88" stopColor="#1488CA" />
        <stop offset="0.94" stopColor="#057AC2" />
        <stop offset="1" stopColor="#0075BF" />
      </radialGradient>
      <clipPath id="clip0_1_74">
        <rect
          width="120"
          height="120"
          fill="white"
          transform="translate(0 15)"
        />
      </clipPath>
    </defs>
  </svg>
)
